module.exports = __webpack_public_path__ + "static/media/clock.e152ab54.png";